<template>
  <transition name="fade">
    <div class="contact-page" id="contact-fullpage">
      <section class="main-container contact-screen contact-slider section" id="contactScreen">
        <div class="flex-container">
          <div class="col-35 fade-in" v-view>
            <div class="headline-0">
             中国办公室
            </div>
          </div>
          <div class="col-65">
            <div class="flip-container no-hide" :class="{hover: isChinaMapHover}">
              <div class="flipper">
                <div class="face  front contact-circle-map contact-china" :style="{zIndex:  zindexf}">
                  <img src="../assets/contact-china.jpg" />
                  <div
                    class="circle-number lightgreen-gradient-bg location-1"
                    @click="(e) => {setChineseCity(e, '澳门总部')}"
                  >1</div>
                  <div
                    class="circle-number lightgreen-gradient-bg location-2"
                    @click="(e) => {setChineseCity(e, '深圳公司')}"
                  >2</div>
                  <div
                    class="circle-number lightgreen-gradient-bg location-3"
                    @click="(e) => {setChineseCity(e, '珠海分公司')}"
                  >3</div>
                  <div
                    class="circle-number lightgreen-gradient-bg location-4"
                    @click="(e) => {setChineseCity(e, '广东绿展科技有限公司')}"
                  >4</div>
                  <div
                    class="circle-number lightgreen-gradient-bg location-5"
                    @click="(e) => {setChineseCity(e, '江西省昌盛投资发展有限公司')}"
                  >5</div>
                  <div class="arrow-up"></div>
                  <div class="location-1-description city-description">澳门</div>
                  <div class="location-2-description city-description">深圳</div>
                  <div class="location-3-description city-description">珠海</div>
                  <div class="location-4-description city-description">佛山</div>
                  <div class="location-5-description city-description">1000KM</div>
                  <div class="location-6-description city-description">南昌</div>
                </div>
                <div class="face back contact-info lightgreen-gradient-bg" :style="{zIndex:  zindexb}">
                   <div class="info-container">
                      <img class="city-pic" v-if="this.currentChineseCity.image" :src="getImgUrl(this.currentChineseCity.image)"/>
                      <div class="city-container">
                        <div class="city-name">{{currentChineseCity.city}}</div>
                        <div class="city-name-description" v-html="currentChineseCity.description"></div>
                        <div class="city-headline-1">地址:</div>
                        <div class="city-address-description" v-html="currentChineseCity.address"></div>
                        <div class="city-headline-1">联系我们:</div>
                        <div class="city-contact-number" v-if="currentChineseCity.tel">电话: {{currentChineseCity.tel}}</div>
                        <div class="btn">
                          <a :href="'mailto:' + currentChineseCity.email" target="_blank" class="gp-button">email</a>
                        </div>
                        <div class="close" @click="clearChineseCity"><img src="../assets/close.png"></div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
 <section class="main-container contact-worldwide contact-slider section" id="contactWorldwide">
        <div class="flex-container">
          <div class="col-35 fade-in" v-view>
            <div class="headline-0">
              全球办公室
            </div>
          </div>
          <div class="col-65">
            <div class="flip-container no-hide" :class="{hover: isWorldMapHover}">
              <div class="flipper">
                <div class=" face front contact-circle-map contact-world" :style="{zIndex: zindexfe}">
                  <img src="../assets/world.jpg" />
                  <!-- <div
                    class="circle-number lightgreen-gradient-bg location-1"
                    @click="(e) => {setWorldCity(e, '硅谷分公司')}"
                  >1</div> -->
                  <div
                    class="circle-number lightgreen-gradient-bg location-2"
                    @click="(e) => {setWorldCity(e, '波士顿分公司')}"
                  >1</div>
                  <!-- <div
                    class="circle-number lightgreen-gradient-bg location-3"
                    @click="(e) => {setWorldCity(e, '维也纳分公司')}"
                  >3</div> -->
                  <div
                    class="circle-number lightgreen-gradient-bg location-4"
                    @click="(e) => {setWorldCity(e, '伦敦分公司')}"
                  >2</div>
                  <div class="location-1-description city-description">美洲</div>
                  <div class="location-2-description city-description">欧洲</div>
                  <div class="location-3-description city-description">非洲</div>
                  <div class="location-4-description city-description">亚洲</div>
                </div>

                <div class="face back contact-info" :style="{zIndex: zindexbe}">
                  <div class="info-container lightgreen-gradient-bg">
                    <img class="city-pic"  v-if="currentWorldCity.image" :src="getImgUrl(this.currentWorldCity.image)" />
                    <div class="city-container">
                      <div class="city-name">{{currentWorldCity.city}}</div>
                      <div class="city-name-description" v-html="currentWorldCity.description"></div>
                      <div class="city-headline-1">地址:</div>
                      <div class="city-address-description" v-html="currentWorldCity.address"></div>
                      <div class="city-headline-1">联系我们:</div>
                      <div class="city-contact-number" v-if="this.currentWorldCity.tel">电话: {{currentWorldCity.tel}}</div>
                      <div class="btn">
                        <a :href="'mailto:' + currentWorldCity.email" target="_blank" class="gp-button">email</a>
                      </div>
                      <div class="close" @click="clearWorldCity"><img src="../assets/close.png"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="main-container contact-us contact-slider section fp-noscroll fp-auto-height-responsive" id="contactUs">
        <div class="flex-container">
          <div class="col-35 fade-in" v-view>
            <div class="headline-0">
              联系我们
            </div>
            <div class="headline-3">
              更多实时动态，请关注官方微信：
              <br/>绿展 Green Prosperity
            </div>
          </div>
          <div class="col-65">
            <div class="contact-us-container lightgreen-gradient-bg">
              <div class="line-5"><b>商务合作</b></div>
              <div class="line-6 line-6__description">
                mkt@greenprosperitygroup.com
                <br />电话：0755-26604489
              </div>
              <div class="line-5"><b>招聘相关</b></div>
              <div class="line-6 line-6__description">
               hr@greenprosperitygroup.com
               <br/>电话：0755-26604489
              </div>
              <div class="line-5"><b>媒体问询</b></div>
              <div class="line-6 line-6__description">
                media@greenprosperitygroup.com
               <br/>电话：0755-26604489
              </div>
            </div>
          </div>
        </div>
        <GPFooter />
      </section>
      <div class="loading-container" v-if="isPending">
        <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      </div>
    </div>
  </transition>
</template>
<style lang="scss" src="./ContactPage.scss"></style>

<script>
import Fullpage from 'fullpage.js'
import { ChineseOffice, WorldOffice } from '../../static/offices.json'
import DataService from '../services/DataService'
import _ from 'lodash'
export default {
  name: 'ContactPage',
  props: {
  },
  data () {
    return {
      contactSliders: null,
      currentChineseCity: {},
      currentWorldCity: {},
      isChinaMapHover: false,
      isWorldMapHover: false,
      ChineseOffice: ChineseOffice,
      WorldOffice: WorldOffice,
      contact: '',
      isPending: false,
      contactError: false,
      zindexf: 1,
      zindexb: 0,
      zindexfe: 1,
      zindexbe: 0
    }
  },
  methods: {
    validateEmail (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },

    validatePhone (phone) {
      const re = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im
      return re.test(String(phone).toLowerCase())
    },
    initFullPage () {
      this.contactSliders = new Fullpage('#contact-fullpage', {
        licenseKey: 'FAE6D29E-C9664B70-A1915489-3CEF9EF7',
        autoScrolling: true,
        lazyLoading: true,
        easingcss3: 'cubic-bezier(0.75, 0, 0.25, 1)',
        fitToSectionDelay: 180,
        fadingEffect: false,
        animateAnchor: false,
        scrollingSpeed: 800,
        scrollBar: true,
        navigation: true,
        navigationPosition: 'left',
        afterResize: (width, height) => {
          if (width < 1024) {
            this.contactSliders.destroy('all')
            this.contactSliders = null
          }
        }
      })
    },
    resizeEvent (e) {
      e.stopPropagation()
      if (document.body.offsetWidth > 1024 && this.contactSliders === null) {
        this.initFullPage()
      }
    },
    getImgUrl (city) {
      let images = require.context('../assets/office/', false, /\.png$/)
      return images('./' + city + '.png')
    },
    setChineseCity (e, city) {
      this.zindexf = 2
      this.zindexb = 2
      this.currentChineseCity = _.find(this.ChineseOffice, ['city', city])
      this.isChinaMapHover = true
    },
    clearChineseCity () {
      this.zindexf = 1
      this.zindexb = 0
      this.isChinaMapHover = false
    },
    setWorldCity (e, city) {
      this.zindexfe = 2
      this.zindexbe = 2
      this.currentWorldCity = _.find(this.WorldOffice, ['city', city])
      this.isWorldMapHover = true
    },
    clearWorldCity () {
      this.zindexfe = 1
      this.zindexbe = 0
      this.isWorldMapHover = false
    },
    submit () {
      let isValid = true
      if (this.validateEmail(this.contact) === false && this.validatePhone(this.contact) === false) {
        this.contactError = true
        isValid = false
      } else {
        this.contactError = false
      }
      if (!isValid) {
        return false
      }
      let info = {
        contact: this.contact
      }
      this.isPending = true
      DataService.contactUs(info).then(response => {
        if (response && response.data === 'ok') {
          alert('Thank you for interest in GPG. One of our team members will contact you soon.')
        } else {
          alert('opps, something went wrong, please try it later.')
        }
        this.contact = ''
        this.contactError = false
        this.isPending = false
      })
    }
  },
  created () {
  },
  destroyed () {
    if (this.contactSliders !== null) {
      this.contactSliders.destroy('all')
      this.contactSliders = null
    }
    window.removeEventListener('resize', this.resizeEvent)
  },
  mounted () {
    window.addEventListener('resize', this.resizeEvent)
    if (document.body.offsetWidth > 1024 && this.contactSliders === null) {
      this.initFullPage()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ContactPage.vue